import { isSuperAdminUser } from "./brandAuth";
import { canAccessGoalProposals } from "./goalProposalsAccess";

function clubIdOf(user) {
  return (
    user?.club_id ||
    user?.club_details?.club_id ||
    user?.club?.club_id ||
    null
  );
}

/**
 * Exercise Proposals — coaches of a club only.
 * Super Admin and users without a club do not see the page.
 * Dual-role users with a coach role still qualify if they belong to a club.
 */
export function canAccessExerciseProposals(user) {
  if (!user) return false;
  if (isSuperAdminUser(user)) return false;
  if (!clubIdOf(user)) return false;

  if (Number(user.type_user_id) === 3) return true;
  if (user.isCoach === true || user.isCoach === "true") return true;

  return canAccessGoalProposals(user);
}
